// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tR","title":"tS","year":"tT","genres":"tU","buttonWrapper":"tV","button":"tW uH"};